var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M29.411 20.815v-5.62c0-2.46-.917-4.68-2.384-6.29-1.476-1.61-3.521-2.6-5.767-2.6-3.583 0-6.626 2.521-7.719 6.026a9.622 9.622 0 00-.432 2.864v5.621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M9.741 20.816h23.038v6.7c0 4.801-3.898 8.698-8.698 8.698H18.44c-4.801 0-8.698-3.898-8.698-8.698v-6.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.26,
    cy: 28.515,
    r: 2.29
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lockFilled.f1bda406e71f067272484a92251d7180.svg";
export { ForwardRef as ReactComponent };